import { SearchValue, UpdateAvailableFilters, UpdateAvailableFiltersReason } from '@shared/services/filters/types';

const getDefaultAllFiltersValue = (): UpdateAvailableFilters => {
  return {
    dataForQueryCount: {},
    data: {},
    searchTerm: '',
    extendedSearch: false,
    reason: UpdateAvailableFiltersReason.systemUpdate,
    _allCount: null,
  };
};
const getDefaultSearchValue = (): SearchValue => {
  return {
    searchTerm: '',
    extendedSearch: false,
  } as SearchValue;
};

export {
  getDefaultAllFiltersValue,
  getDefaultSearchValue,
}
